<app-actions [mode]="'menu'" [items]="moreMenuItems">
  <button
    tuiIconButton
    type="button"
    iconStart="@tui.ellipsis-vertical"
    [appearance]="'lp-icon-block'"
    [size]="size"
  ></button>
</app-actions>
